var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('web-viewer-component',{attrs:{"scale":"1","url":"https://9563094b2079481587bdeaf6beac810a.vfs.cloud9.us-west-2.amazonaws.com/file/test"}})}
var staticRenderFns = []

export { render, staticRenderFns }